// 未認証時はログイン画面、家族未所属時は家族作成画面に誘導
import { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginPage from '../pages/Login';

export default function AuthGuard({ children }: { children: ReactNode }) {
  const { user, family, loading, disabled, ensureFamily } = useAuth();
  const [creatingFamily, setCreatingFamily] = useState(false);

  useEffect(() => {
    if (user && !family && !creatingFamily) {
      setCreatingFamily(true);
      ensureFamily().finally(() => setCreatingFamily(false));
    }
  }, [user, family, creatingFamily, ensureFamily]);

  if (disabled) {
    return (
      <div className="card">
        <h2>⚠️ Supabase未設定</h2>
        <p>DB機能が無効化されています。環境変数 <code>VITE_SUPABASE_URL</code> と <code>VITE_SUPABASE_ANON_KEY</code> を設定してください。</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="card" style={{ textAlign: 'center' }}>
        <p className="muted">読み込み中...</p>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  if (!family) {
    return (
      <div className="card" style={{ textAlign: 'center' }}>
        <p className="muted">家族グループを準備しています...</p>
      </div>
    );
  }

  return <>{children}</>;
}
